export const DEFAULT_INSTRUMENT = 'grand-piano';
export const INSTRUMENTS = Object.freeze([
  { id: DEFAULT_INSTRUMENT, name: 'Grand Piano', description: 'A recorded acoustic grand, with a natural attack and ringing strings.' },
  { id: 'electric-piano', name: 'Electric Piano', description: 'Bell-like FM keys, from soft and mellow to bright and percussive.' },
  { id: 'warm-pad', name: 'Warm Pad', description: 'Soft, slowly swelling chords with a warm analog character.' },
  { id: 'synth-strings', name: 'Synth Strings', description: 'A lush, layered string sound for sustained chords and melodies.' },
  { id: 'analog-lead', name: 'Analog Lead', description: 'A bright, rounded saw lead with a little vintage detuning.' },
  { id: 'synth-pluck', name: 'Synth Pluck', description: 'A crisp, short synth sound for rhythmic patterns and arpeggios.' },
]);
export const isInstrument = id => INSTRUMENTS.some(instrument => instrument.id === id);
export const normalizeInstrument = id => isInstrument(id) ? id : DEFAULT_INSTRUMENT;
